<!-- GameCarousel.vue -->
<script setup>
const props = defineProps({
  games: {
    type: Array,
    default: () => [],
  },
  isLoading: Boolean,
  title: String,
  baseLink: {
    type: String,
    default: '/casino',
  },
  category: {
    type: Object,
    default: () => ({ id: 1, name: 'slots', slug: 'slots' }), 
  },
});


const categorySlug = encodeURIComponent(props.category.slug);

</script>

<template>
  <BaseCarousel
    :title="title"
    button-label="Ver todos"
    :button-link="`${baseLink}/${categorySlug}`"
    :is-loading="isLoading"
  >
    <template v-slot:default="slotProps">
      <BaseGame
        v-if="slotProps.isLoading"
        shimmer
        v-for="index in 11"
        :key="index"
      />
      <BaseGame
        v-if="!slotProps.isLoading"
        :data="game"
        v-for="game in games"
        :key="game.id"
      />
    </template>
  </BaseCarousel>
</template>
